import { ConfigManager } from '../../../../../../../application/config/ConfigManager';
import { useI18n } from '../../../../../../../application/language/useI18n';
import { NotificationType } from '../../../../../../../service/notification/INotificationModel';
import { UserSystemRoleModelPermissionMap } from '../../../../../../../service/systemRole/entity/actions/UserSystemRoleModelPermissionMap';

export const notificationMapValues = [
  // {
  //   value: NotificationType.CREATE_SYSTEM_ROLE,
  //   name: 'Уведомление о создании новой системной или проектной роли',
  // },
  {
    value: NotificationType.CHANGE_STATUS,
    name: 'Уведомление о переводе всех существующих “Статусов” для требований в одно из существующих значений',
  },
  // {
  //   value: NotificationType.CREATE_ADMIN,
  //   name: 'Уведомление добавлении нового администратора (в т.ч. локального администратора)',
  // },
  {
    value: NotificationType.UPSERT_PROJECT,
    name: 'Создание нового / Изменение текущего проекта',
  },
  {
    value: NotificationType.CREATE_APPLICATION,
    name: 'Создание новой Анкеты АС в Проекте',
  },
  {
    value: NotificationType.EDIT_APPLICATION,
    name: 'Изменение существующей Анкеты АС в Проекте',
  },
  {
    value: NotificationType.TRANSFER_APPLICATION,
    name: 'Перенос Анкеты АС в другой Проект',
  },
  {
    value: NotificationType.COPY_APPLICATION,
    name: 'Копирование Анкеты АС в другой Проект',
  },
  {
    value: NotificationType.REQUIREMENT_ACCEPT,
    name: 'Обновление набора требований АС после изменения шаблонов требований',
  },
  // {
  //   value: NotificationType.CREATE_COMMENT_JIRA,
  //   name: 'Создание нового комментария к требованию в Jira',
  // },
  // {
  //   value: NotificationType.CREATE_REQUIREMENT,
  //   name: 'Создание нового требования в АС',
  // },
  {
    value: NotificationType.CREATE_TEMPLATE,
    name: 'Создание нового Шаблона требований',
  },
  {
    value: NotificationType.EDIT_REQUIREMENT_TEMPLATE,
    name: 'Обновление Шаблона требования',
  },
  {
    value: NotificationType.DELETE_REQUIREMENT_TEMPLATE,
    name: 'Удаление Шаблона требования',
  },
  // {
  //   value: NotificationType.EDIT_ADDITIONAL_COLUMN_CONTENT,
  //   name: 'Изменение содержимого доп колонки',
  // },
  // {
  //   value: NotificationType.EDIT_PASSWORD,
  //   name: 'Уведомление об изменении пароля локальных УЗ',
  // },
  // {
  //   value: NotificationType.EDIT_REQUIREMENT,
  //   name: 'Уведомление об изменении требования',
  // },
  // {
  //   value: NotificationType.EDIT_ROLES_GROUP,
  //   name: 'Уведомление об изменении состава групп (изменение в ролевой модели, добавление пользователей)',
  // },
  // {
  //   value: NotificationType.UPSERT_ADDITIONAL_COLUMN,
  //   name: 'Уведомление об изменении/ добавлении доп.колонок',
  // },
  // {
  //   value: NotificationType.INCLUDE_EXCLUDE_REQUIREMENT,
  //   name: 'Принятие/исключение требований в уже заполненных анкетах (красные/ синие маркеры)',
  // },
];

export const useNoProjectRolePermissionDropdownValues = () => {
  const { translate } = useI18n();

  const noProjectRoleDefaultValues = [
    {
      value: UserSystemRoleModelPermissionMap['project-not-in-team-permission-create-project'], // права
      name: translate('systemRoles.addRoleModal.creatingProjects'),
    },
    {
      value: UserSystemRoleModelPermissionMap['project-not-in-team-permission-update-team-project'],
      name: translate('systemRoles.addRoleModal.editingProjectTeams'),
    },
    {
      value: UserSystemRoleModelPermissionMap['project-not-in-team-permission-update-fields-project'],
      name: translate('systemRoles.addRoleModal.editingProjectFields'),
    },
    {
      value: UserSystemRoleModelPermissionMap['project-not-in-team-permission-delete-project'],
      name: translate('systemRoles.addRoleModal.deletingProjects'),
    },
    {
      value: UserSystemRoleModelPermissionMap['project-not-in-team-permission-create-application'],
      name: translate('systemRoles.addRoleModal.creatingSystems'),
    },
    {
      value: UserSystemRoleModelPermissionMap['project-not-in-team-permission-update-application'],
      name: translate('systemRoles.addRoleModal.updatingSystems'),
    },
    {
      value: UserSystemRoleModelPermissionMap['project-not-in-team-permission-delete-application'],
      name: translate('systemRoles.addRoleModal.deletingSystems'),
    },
    {
      value: UserSystemRoleModelPermissionMap['project-not-in-team-permission-report-access'],
      name: translate('systemRoles.addRoleModal.accessToReports'),
    },
    {
      value: UserSystemRoleModelPermissionMap['project-not-in-team-permission-show-unverified-requirements-access'],
      name: translate('systemRoles.addRoleModal.viewingUnverifiedRequirements'),
    },
    {
      value: UserSystemRoleModelPermissionMap['project-not-in-team-permission-custom-requirement-access'],
      name: translate('systemRoles.addRoleModal.accessToCreatingOrEditingLocalRequirements'),
    },
    {
      value: UserSystemRoleModelPermissionMap['project-not-in-team-permission-accept-cancel-access'],
      name: translate('systemRoles.addRoleModal.acceptingOrCancelingRequirements'),
    },
    {
      value: UserSystemRoleModelPermissionMap['project-not-in-team-permission-show-regulators'],
      name: translate('systemRoles.addRoleModal.viewingRequirementsOfExternalRegulatoryAuthorities'),
    },
    {
      value: UserSystemRoleModelPermissionMap['project-not-in-team-permission-jira-intergration'],
      name: translate('systemRoles.addRoleModal.integratingAsWithJira'),
    },
  ];

  const noProjectRoleAsmValues = [
    {
      value: UserSystemRoleModelPermissionMap['project-not-in-team-permission-create-project'], // права
      name: translate('systemRoles.addRoleModal.creatingProjects'),
    },
    {
      value: UserSystemRoleModelPermissionMap['project-not-in-team-permission-update-team-project'],
      name: translate('systemRoles.addRoleModal.editingProjectTeams'),
    },
    {
      value: UserSystemRoleModelPermissionMap['project-not-in-team-permission-update-fields-project'],
      name: translate('systemRoles.addRoleModal.editingProjectFields'),
    },
    {
      value: UserSystemRoleModelPermissionMap['project-not-in-team-permission-delete-project'],
      name: translate('systemRoles.addRoleModal.deletingProjects'),
    },
    {
      value: UserSystemRoleModelPermissionMap['project-not-in-team-permission-create-application'],
      name: translate('systemRoles.addRoleModal.creatingSystems'),
    },
    {
      value: UserSystemRoleModelPermissionMap['project-not-in-team-permission-update-application'],
      name: translate('systemRoles.addRoleModal.updatingSystems'),
    },
    {
      value: UserSystemRoleModelPermissionMap['project-not-in-team-permission-delete-application'],
      name: translate('systemRoles.addRoleModal.deletingSystems'),
    },
    {
      value: UserSystemRoleModelPermissionMap['project-not-in-team-permission-report-access'],
      name: translate('systemRoles.addRoleModal.accessToReports'),
    },
  ];
  
  return ConfigManager.getConfig().extensions.include.includes('asm') ? noProjectRoleAsmValues : noProjectRoleDefaultValues
}

export const useNotificationMapValues = () => {
  const { translate } = useI18n();

  const defaultValues = [
    {
      value: NotificationType.CHANGE_STATUS,
      name: translate(
        'systemRoles.addRoleModal.notificationAboutChangingAllStatusesForRequirementsToOneOfTheAvailableValues',
      ),
    },
    {
      value: NotificationType.UPSERT_PROJECT,
      name: translate('systemRoles.addRoleModal.creatingANewProjectOrChangingTheCurrentProject'),
    },
    {
      value: NotificationType.CREATE_APPLICATION,
      name: translate('systemRoles.addRoleModal.creatingANewAsProfileInTheProject'),
    },
    {
      value: NotificationType.EDIT_APPLICATION,
      name: translate('systemRoles.addRoleModal.changingAnExistingAsProfileInTheProject'),
    },
    {
      value: NotificationType.TRANSFER_APPLICATION,
      name: translate('systemRoles.addRoleModal.transferringAnAsProfileToAnotherProject'),
    },
    {
      value: NotificationType.COPY_APPLICATION,
      name: translate('systemRoles.addRoleModal.copyingAnAsProfileToAnotherProject'),
    },
    {
      value: NotificationType.REQUIREMENT_ACCEPT,
      name: translate('systemRoles.addRoleModal.updatingTheAsRequirementsSetAfterChangingTheRequirementsTemplates'),
    },
    {
      value: NotificationType.CREATE_TEMPLATE,
      name: translate('systemRoles.addRoleModal.creatingANewRequirementsTemplate'),
    },
    {
      value: NotificationType.EDIT_REQUIREMENT_TEMPLATE,
      name: translate('systemRoles.addRoleModal.updatingARequirementsTemplate'),
    },
    {
      value: NotificationType.DELETE_REQUIREMENT_TEMPLATE,
      name: translate('systemRoles.addRoleModal.deletingARequirementsTemplate'),
    },
  ];

  const asmValues = [
    {
      value: NotificationType.UPSERT_PROJECT,
      name: translate('systemRoles.addRoleModal.creatingANewProjectOrChangingTheCurrentProject'),
    },
    {
      value: NotificationType.CREATE_APPLICATION,
      name: translate('systemRoles.addRoleModal.creatingANewAsProfileInTheProject'),
    },
    {
      value: NotificationType.EDIT_APPLICATION,
      name: translate('systemRoles.addRoleModal.changingAnExistingAsProfileInTheProject'),
    },
    {
      value: NotificationType.TRANSFER_APPLICATION,
      name: translate('systemRoles.addRoleModal.transferringAnAsProfileToAnotherProject'),
    },
    {
      value: NotificationType.COPY_APPLICATION,
      name: translate('systemRoles.addRoleModal.copyingAnAsProfileToAnotherProject'),
    },
    {
      value: NotificationType.REQUIREMENT_ACCEPT,
      name: translate('systemRoles.addRoleModal.updatingTheAsRequirementsSetAfterChangingTheRequirementsTemplates'),
    },
    {
      value: NotificationType.CREATE_TEMPLATE,
      name: translate('systemRoles.addRoleModal.creatingANewRequirementsTemplate'),
    },
    {
      value: NotificationType.EDIT_REQUIREMENT_TEMPLATE,
      name: translate('systemRoles.addRoleModal.updatingARequirementsTemplate'),
    },
    {
      value: NotificationType.DELETE_REQUIREMENT_TEMPLATE,
      name: translate('systemRoles.addRoleModal.deletingARequirementsTemplate'),
    },
  ];
  
  return ConfigManager.getConfig().extensions.include.includes('asm') ? asmValues : defaultValues

};
